define(['lib/tentacle/tentacle'], function (Tentacle) {

    Tentacle.registerFilters({

        bool: function (value) {
            return !!value;
        },

        not: function (value) {
            return !value;
        },

        isnull: function (value) {
            return _.isNull(value);
        },

        number: function (value) {
            return +value;
        },

        in: function () {
            return Array.prototype.slice.call(arguments, 1).includes(arguments[0]);
        },

        array: function (value) {
            return _.isArray(value) ? value : [value];
        },

        strsort: function (value) {
            return _.isArray(value) ? value.sort(function (a, b) { return a.localeCompare(b); }) : value;
        },

        eq: function (value, other) {
            return value === other;
        },

        gt: function (value, other) {
            return value > other;
        },

        lt: function (value, other) {
            return value < other;
        },

        contains: function (value, other) {
            return _.contains(value, other);
        },

        publish: {
            read: function (value) { return value; },
            publish: function (value, arg) { return arg; }
        },

        args: function () {
            return Array.prototype.slice.call(arguments);
        },

        join: function (array, sep) {
            return array.join(sep);
        },

        pluck: function (array, attr) {
            return array.map(function (el) {
                return el.get(attr);
            });
        },

        length(value, attr) {
            return value.length;
        }

    });

});
